import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import PrimaryButton from "../../../Components/Buttons/primary-button";

import { useModalContext } from "../../../Contexts/ModalContext";

import { getStakeDebitAPIObject } from "../../../Utils/api-data-transforms";
import { isSVDVerificationRequired } from "../../../Utils/helpers";
import { modalVariants } from "../../../Utils/constants";

import { CircleExclamationOutlined } from "../../../Assets/Icons";

import "./finish-stake-saver-setup.scss";

export default function renderFinishStakeSaverSetup(modalContext, props) {
  const { updateModalComponent, pushModalStack, setModalClassName, setModalTitle, setModalVariant } = modalContext;

  updateModalComponent(() => <FinishStakeSaverSetup {...props} />);
  pushModalStack(() => renderFinishStakeSaverSetup(modalContext, props));
  setModalTitle("Stake Saver Setup");
  setModalVariant(modalVariants.flexDialog);
  setModalClassName("finish-stake-saver-setup no-full-screen");
}

const FinishStakeSaverSetup = ({ setupStakeSaverData }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const { onModalClose } = useModalContext();

  const stakeCheckingOffer = setupStakeSaverData?.stake_checking;

  const creditBuilderOffer = setupStakeSaverData?.credit_builder;

  const IsSVDVerificationRequired = useMemo(() => {
    return isSVDVerificationRequired(
      getStakeDebitAPIObject(setupStakeSaverData?.stake_checking?.stake_checking_status),
    );
  }, [setupStakeSaverData]);

  const handleCTAClick = () => {
    if (IsSVDVerificationRequired) {
      navigate("/verify-stake-checking", { state: { previousPathname: pathname } });
    }
    onModalClose();
  };

  const secondaryCTAClick = () => {
    onModalClose();
  };

  return (
    <>
      <div className="modal-dialog-content">
        <div className="stake-saver-sub-items">
          {!!stakeCheckingOffer && (
            <div className="stake-saver-sub-item">
              <div className="stake-saver-sub-item-icon">
                <img src={stakeCheckingOffer.image_link} alt={stakeCheckingOffer.title} />
              </div>
              <div className="stake-saver-sub-item-content">
                <h4 className="stake-saver-sub-item-title">{stakeCheckingOffer.title}</h4>
                <span className="stake-saver-sub-item-description">{stakeCheckingOffer.status_briefing}</span>
              </div>
              <div className={`stake-saver-sub-status-badge ${stakeCheckingOffer?.status_badge_type}`}>
                {stakeCheckingOffer.status_display_text}
              </div>
            </div>
          )}
          {!!creditBuilderOffer && (
            <div className="stake-saver-sub-item">
              <div className="stake-saver-sub-item-icon">
                <img src={creditBuilderOffer.image_link} alt={creditBuilderOffer.title} />
              </div>
              <div className="stake-saver-sub-item-content">
                <h4 className="stake-saver-sub-item-title">{creditBuilderOffer.title}</h4>
                <span className="stake-saver-sub-item-description">{creditBuilderOffer.status_briefing}</span>
              </div>
              <div className={`stake-saver-sub-status-badge ${creditBuilderOffer?.status_badge_type}`}>
                {creditBuilderOffer.status_display_text}
              </div>
            </div>
          )}
        </div>
        {!!setupStakeSaverData?.offer_status_summary && (
          <div className="info-alert positive mt-4">
            <CircleExclamationOutlined />
            <div>
              {setupStakeSaverData?.offer_status_summary_title}
              <div className="text-xs-regular mt-1">{setupStakeSaverData?.offer_status_summary}</div>
            </div>
          </div>
        )}
      </div>
      <div className="action-container">
        <PrimaryButton onClick={handleCTAClick}>
          {IsSVDVerificationRequired ? "Start Verification" : "Got It"}
        </PrimaryButton>
        {IsSVDVerificationRequired && (
          <PrimaryButton className="secondary-colors" onClick={secondaryCTAClick}>
            Later
          </PrimaryButton>
        )}
      </div>
    </>
  );
};
